// NPM
import * as React from "react"
import { graphql } from "gatsby"
import _ from "lodash"

// Components
import Layout from "src/layouts/en"
import DegreeHub from "src/components/pages/DegreeHub/DegreeHub"

const DegreeHubPageEn = ({ location, data }) => {
  const topNav = data.topNav
  const sections = _.get(data, `degreeHubPage.sections`, [])
  const bottomNav = data.bottomNav
  const socialMedia = _.get(data, `socialMedia.nodes`, [])

  return (
    <Layout
      location={location}
      topNav={topNav}
      page={data.degreeHubPage}
      bottomNav={bottomNav}
      socialMedia={socialMedia}
    >
      <DegreeHub sections={sections} />
    </Layout>
  )
}

export default DegreeHubPageEn

export const query = graphql`
  query DegreeHubPageEnQuery($id: String) {
    topNav: strapiTopNav(locale: { eq: "en" }) {
      ...topNavContent
    }

    degreeHubPage: strapiPage(id: { eq: $id }) {
      ...pageInformation
    }

    bottomNav: strapiBottomNav(locale: { eq: "en" }) {
      ...bottomNavContent
    }

    socialMedia: allStrapiSocialMedia(filter: { locale: { eq: "en" } }) {
      nodes {
        ...socialMedia
      }
    }
  }
`
